/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class LatestRoute extends Route {
  // Services
  @service
  store;

  model() {
    let group = this.modelFor('group');
    let progressModel = this.modelFor('group.insights.progress');

    return hash({
      group,
      learners: this.modelFor('group.insights').learners,
      goalSubjects: progressModel.subjects,
      levels: this.store.findAll('milestones/level'),
      progressions: this.store.query('milestones/progression', {
        groupId: group.id,
        latest: true,
        type: ProgressionType.PROGRESSION,
      }),
      milestones: progressModel.milestones,
      milestoneSets: progressModel.milestoneSets,
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    let progressController = this.controllerFor('group/insights/progress');
    let subjectId = progressController.get('subjectId');
    if (isEmpty(subjectId)) {
      // Default to first subject if unset - this prevents errors when the user
      // navigates to a subject-based report after freshly loading this route.
      subjectId = model.goalSubjects[0].id;
    }
    this.controllerFor('group/insights/progress').setProperties({
      report: 'latest',
      subjectId,
    });
  }
}
